import MobileMenu from './modules/MobileMenu';
// import bootstrap from '../../node_modules/bootstrap/dist/js/bootstrap.bundle.min';
// import bootstrapSlim from '../../node_modules/jquery/dist/jquery.slim.min';

/* Instansier objekter */
const mobileMenu = new MobileMenu();

let el = document.getElementsByClassName('menu-item-has-children');
for (let item of el) {
  item.addEventListener('mouseenter', function(e) {
    item.classList.add('open');
  });
  item.addEventListener('mouseleave', function(e) {
    item.classList.remove('open');
  });
}